import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BudgetReport from './components/BudgetReport';

const BudgetPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Budget Control and Report</h3>
      </Col>
    </Row>
    <Row>
      <BudgetReport />
    </Row>
  </Container>
);

export default BudgetPage;
